import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { TOTAL_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ExportIncomeYearFieldsPct from './ExportIncomeYearFieldsPct';

const ExportIncomeTotalPct = () => {
  const { exportIncome } = useIncomeStructure();

  const totalExportIncomePct = findMasterDataById(
    exportIncome,
    TOTAL_INCOME_STRUCTURE_ID.TOTAL_EXPORT_INCOME
  );

  return (
    <>
      {totalExportIncomePct && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
              {totalExportIncomePct.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsPct
            keyItem={totalExportIncomePct.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ExportIncomeTotalPct;
